let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hgVVP"), load("4j2De")]).then(() => parcelRequire('fqv9g'));